import React, { useState } from "react";
import ToBeAccountantBlock from "./toBeAccountantBlock";
import { Checkbox } from "antd";
import { FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Filter from "./filter";
import EmptyDashboardData from "./emptyDashboardData";

const ToBeAccountantContent = ({  
  setUuidCurrentFilter,
  initialNexPage,
  selectedDocuments, 
  setSelectedDocuments,    
  filterChips, 
  setFilterChips,
  setDocNumberFilter,
  docNumberFilter,  
  accountCodeFilter,
  setAccountCodeFilter,
  movementsFiltersChips,
  setMovementsFiltersChips,
  includesFilter,
  onCheckIncludesFilter,
  onChangeDocDate,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,  
  closeMoreFilter,
  setCloseMoreFilter,
  monthsSelectValue,
  setMonthsSelectValue,
  months,
  setMonths,
  yearFilter,
  setYearFilter,
  quarterFilter,
  setQuarterFilter,
  isBankTransactionActive,
  setIsBankTransactionActive,
  goToDetail,
  allChecked,
  setAllChecked
}) => {

  const dashboardData = useSelector(state => state.precog.dashboardData?.data);
  const dashboardNextUrlPaginate = useSelector(state => state.precog.dashboardData?.nextUrl);
  const dashboardDataStatus = useSelector(state => state.precog.dashboardData?.status);

  const [allDocumentsSelected, setAllDocumentsSelected] = useState(false);
  const [idsSelected, setIdsSelected] = useState([]);

  useEffect(() => {
    setSelectedDocuments(allDocumentsSelected ? [...idsSelected] : []);
  }, [allDocumentsSelected]);

  const onCheckAll = () => {
    setAllChecked(!allChecked);
    setAllDocumentsSelected(!allDocumentsSelected);
    const filteredData = dashboardData?.filter(d => d.draftStatus.isConfirmable);
    const ids = filteredData?.map(d => d.id);
    setIdsSelected([...ids]);
  };

  return (
    <>
      <Filter 
        closeMoreFilter={closeMoreFilter} 
        setCloseMoreFilter={setCloseMoreFilter}
        monthsSelectValue={monthsSelectValue} 
        setMonthsSelectValue={setMonthsSelectValue}
        months={months} 
        setMonths={setMonths}
        yearFilter={yearFilter} 
        setYearFilter={setYearFilter}
        quarterFilter={quarterFilter} 
        setQuarterFilter={setQuarterFilter}
        isBankTransactionActive={isBankTransactionActive} 
        setIsBankTransactionActive={setIsBankTransactionActive}       
        filterChips={filterChips} 
        setFilterChips={setFilterChips} 
        docNumberFilter={docNumberFilter}
        setDocNumberFilter={setDocNumberFilter}
        accountCodeFilter={accountCodeFilter}
        setAccountCodeFilter={setAccountCodeFilter}
        movementsFiltersChips={movementsFiltersChips}
        setMovementsFiltersChips={setMovementsFiltersChips}
        includesFilter={includesFilter}
        onCheckIncludesFilter={onCheckIncludesFilter}
        onChangeDocDate={onChangeDocDate}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        dateFrom={dateFrom}
        dateTo={dateTo}        
        setUuidCurrentFilter={setUuidCurrentFilter}
      />
      { dashboardData?.length > 0 &&
           <div className="precog-toBeAccountant-titles-container">
             <div className="documents-selector-container">
               <Checkbox checked={allChecked} onChange={() => onCheckAll()}><b style={{textTransform: "capitalize"}} className="title"><FormattedMessage id="preCog.accountingTab.documents"/></b></Checkbox>
             </div>
             <div className="accounting-text-container">
               <b style={{textTransform: "capitalize"}} className="title">
                 <FormattedMessage id="preCog.accountingTab.registration"/>
               </b>
             </div>
           </div>
      }
      {
        (dashboardDataStatus?.ended && dashboardData?.length === 0) ?
          <EmptyDashboardData>
            <>
              <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_filtered" /></p>
              <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_tryAgain" /></p>
            </>
          </EmptyDashboardData>  
          :
          <ToBeAccountantBlock
            initialNexPage={initialNexPage}
            invoices={dashboardData}
            selectedDocuments={selectedDocuments}
            setSelectedDocuments={setSelectedDocuments}
            allDocumentsSelected={allDocumentsSelected}
            setAllDocumentsSelected={setAllDocumentsSelected}
            dashboardNextUrlPaginate={dashboardNextUrlPaginate}
            goToDetail={goToDetail}
          />          
      }     
    </>
  );
};

export default ToBeAccountantContent;